import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { HelpersService } from "./helpers.service";
import { catchError, concatMap, delay, map, of, retryWhen, throwError } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable()


export class DashboardService extends HelpersService {

    constructor(router: Router, http: HttpClient, translate: TranslateService, dialog: MatDialog) {
        super(router, http, translate, dialog)
    }

    public getList() {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/cards`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getOrder(orderId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${orderId}/details`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getAsset(assetId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/${assetId}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getCases() {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/cases`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getCase(id: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/cases/${id}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getTypes(assetId?: any) {
        let url = `${this.config.BASEURL_ORDER_API}/v1/secured/cases/types`
        if(assetId) {
            url = `${url}?assetId=${assetId}`;
        }
        return this.http.get(url, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public create(req: any) {
        return this.http.post(`${this.config.BASEURL_ORDER_API}/v1/secured/cases`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public sendComment(caseId: string, req: any) {
        return this.http.post(`${this.config.BASEURL_ORDER_API}/v1/secured/cases/${caseId}/comment`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getAttachment(attachmentId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/cases/attachments/${attachmentId}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getDriversList() {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/drivers`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getDriver(id: string) {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/drivers/${id}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public chooseMainDriver(id: string, req: any) {
        return this.http.patch(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/${id}/driver`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public addDriver(req: any) {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/drivers`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updateAddress(req: any) {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/billing-address`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updatePlate(req: any, id: string) {
        return this.http.patch(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${id}/vehicle/plate-number`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getPaymentMethod(id: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${id}/payments/funding-instructions`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getDeviceManual(id: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${id}/device-manual`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public idOneOffRenewalProcess(id: string) {
        return this.http.post(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/${id}/renew`, null, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public checkOrderBCR(bcrId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/check/${bcrId}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            retryWhen(errors => errors.pipe(
                concatMap((e, i) =>
                    i < this.config.RENEW_MAX_RETRIES || this.config.RENEW_MAX_RETRIES === 0  ? of(e).pipe(delay(this.config.RENEW_RETRY_DELAY_MS)) : throwError("renew-not-synced-error"),
                )
            )),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getOrderDocuments(orderId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/orders/${orderId}/documents`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }
    
    public getAssetDocuments(assetId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/${assetId}/documents`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getAssetLatestDoc(assetId: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/${assetId}/document/detail`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public downloadAssetDocuments(orderId: String, type: string) {
        return this.http.get(`${this.config.BASEURL_ORDER_API}/v1/secured/assets/${orderId}/download-document?documentType=${type}`, this.getHTTPHeaderPDF(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getDocumentsPolicies() {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/agreements`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getUrlDocument(id: String) {
       return `${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/agreements/${id}`;
    }

    public getUrlOrderDocument(orderId: String, type: String) {
       return `${this.config.BASEURL_ORDER_API}/v1/secured/orders/${orderId}/download-document?documentType=${type}`;
    }

    public getUrlAssetDocument(orderId: String, type: String) {
       return `${this.config.BASEURL_ORDER_API}/v1/secured/assets/${orderId}/download-document?documentType=${type}`;
    }

    public downloadSingleDocument(id: String) {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/agreements/${id}`, this.getHTTPHeaderPDF(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updateMarketing(req: any) {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/marketing-consent`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }
    
    public downloadFilePdf(url: string) {
        return this.http.get(`${url}`, this.getHTTPHeaderPDF(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return throwError(error);
                // return this.handleError(error);
            })
        )
    }
}
